import React, { useState, useContext, useEffect } from 'react';
import { Drawer, IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import { navbarHeight } from '../../config';
import '../Topmenu.css';
import SourceLocationDialog from './SourceLocationDialog';  
import RegionCreateControls from './RegionCreateControls';
import ROISelector from './ROISelector';
import GeneGrid from './GeneGrid';
import { LayerContext} from '../LayerContext';
import { CatalogContext } from '../CatalogContext';

const ROIDrawer = ({ isOpen, onClose }) => {
  
  const { layers } = useContext(LayerContext);
  const { catalog } = useContext(CatalogContext);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [fullDepthSgeFile, setFullDepthSgeFile] = useState("");
  const [geneCountFile, setGeneCountFile] = useState("");
  
  const [baseRoi, setBaseRoi] = useState({});
  const [rois, setRois] = useState([]);  // Declare rois state
  const [tableData, setTableData] = useState([]);
   
  const fetchBaseline = async () => {
    if (geneCountFile!=="") {
      const res = await fetch(geneCountFile);
      const rawData = await res.json();
      const baseRoi = {
        'id': 'l-roi-WholeLane',
        'title': `Baseline`,
        'boundary': {},
        'color': '#010101',
        'totalCount': rawData['sum']['cnt_total'],
        'countByGene': rawData['count']['cnt_total'],
      };
      return baseRoi;
    }
  }
  
  useEffect(() => {
    setGeneCountFile(catalog?.assets.sge.stat || '');
  }, [catalog]);
  useEffect(() => {
    setFullDepthSgeFile(catalog?.assets.sge.fullDepth|| '');
  }, [catalog]);
  useEffect(()=>{
    updateRois();
  }, [geneCountFile])

  const updateRois = async () => {
    try {
      if (geneCountFile!=="") {
        const filteredLayers = layers.filter(layer => (layer.assetType === 'roi') && layer?.totalCount);
        const newBaseRoi = await fetchBaseline();
        setBaseRoi(newBaseRoi)
        setRois([newBaseRoi, ...filteredLayers]);  // Prepend baseRoi to the filtered layers
      }
    } catch (error){
      console.log("Error loading fetching gene list:", error)
    }
  };
  useEffect(() => {
    if (geneCountFile!=="") {
      updateRois();
    }
  }, [layers]);  // Empty dependency array to run once on mount

    
  return (
    <>
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      variant="persistent"
      PaperProps={{ style: { width: '400px', top: navbarHeight } }}
      className='topmenu-drawer'
    >
      <div className='top-container' style={{justifyContent: "space-between"}}>
        <RegionCreateControls rois={rois} fullDepthSgeFile={fullDepthSgeFile} />
        <IconButton onClick={() => setDialogOpen(true)} >
          <SettingsIcon />
        </IconButton>
      </div>
      <div className="plaintext">  Total SGE counts: {baseRoi?.totalCount}, ROI counts: {rois.length -1 } </div>
      <ROISelector rois={rois} setTableData={setTableData} />
      <div className='topmenu-content'>
        <GeneGrid tableData={tableData} />
      </div>
    </Drawer>
    <SourceLocationDialog
      dialogOpen={dialogOpen}
      setDialogOpen={setDialogOpen}
      fullDepthSgeFile={fullDepthSgeFile}
      setFullDepthSgeFile={setFullDepthSgeFile}
    />
    </>
  );
}

const colorsTab10 = {
  0: '#1f77b4',
  1: '#ff7f0e',
  2: '#2ca02c',
  3: '#d62728',
  4: '#9467bd',
  5: '#8c564b',
  6: '#e377c2',
  7: '#7f7f7f',
  8: '#bcbd22',
  9: '#17becf',
  10: '#f5b3ae',
  11: '#a5dea4'
};


export default ROIDrawer;

